import React, { useState } from "react";
import { DialogProps, makeDialogOpener, useDialogSize, GridItem, Grid, PullRight } from "@optimed/react";
import { Button, DialogContent, Table } from "@optimed/react";
import { mappingService } from "../api";
import { DoctorWithAddress, HisDoctorWithUnit } from "../api/models";
import { DoctorOptimedLabel } from "./DoctorOptimedLabel";
import { Identifier } from "./Identifier";

interface DoctorMappingDialogProps extends DialogProps<void> {
  docplannerDoctor: DoctorWithAddress;
  hisDoctors: HisDoctorWithUnit[];
}

export function DoctorMappingDialog(props: DoctorMappingDialogProps) {
  const { dialog } = props;
  useDialogSize("800px", "80%");
  const [selectedHisDoctor, setSelectedHisDoctor] = useState<HisDoctorWithUnit>();

  const onAccept = () => {
    if (!selectedHisDoctor) return;

    mappingService
      .postDoctor({
        docplannerDoctorId: props.docplannerDoctor.doctor?.id,
        docplannerAddressId: props.docplannerDoctor.address?.id,
        hisDoctorId: selectedHisDoctor.doctor?.id?.toString(),
        hisUnitId: selectedHisDoctor.unit?.id?.toString(),
      })
      .then(() => dialog.close());
  };

  return (
    <DialogContent header="Ustaw mapowanie lekarza">
      <Grid>
        <GridItem rowTemplate="1fr" scrollable>
          <Table>
            <tbody>
              {props.hisDoctors.map(x => (
                <tr
                  key={x.key}
                  className={x === selectedHisDoctor ? "table-active" : undefined}
                  onClick={() => setSelectedHisDoctor(x)}
                >
                  <td>
                    <DoctorOptimedLabel doctor={x.doctor} hideId />
                    <PullRight>
                      <Identifier value={x.doctor?.id} />
                    </PullRight>
                  </td>
                  <td>
                    {x.unit?.nazwa}
                    <PullRight>
                      <Identifier value={x.unit?.id} />
                    </PullRight>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </GridItem>
        <GridItem rowTemplate="auto" className="text-end">
          <Button text="Anuluj" onClick={dialog.cancel} />
          <Button text="Zatwierdź" onClick={onAccept} />
        </GridItem>
      </Grid>
    </DialogContent>
  );
}

export const doctorMappingDialog = makeDialogOpener(DoctorMappingDialog);
